import { gql } from "@apollo/client";
import { PayerTransactionsFilter } from "./GetPaymentTransactions";

/**
 * Monthly charges for PayerOverview. AUT-6162: the park aggregate counts only the "Usage Fee"
 * transaction types (USAGE_FEE_TRANSACTION_TYPES: park, trip_charge -- keep the two lists in sync),
 * and the gateway aggregate requires a non-null gateway type, so adjustments (chargebacks/credits,
 * null gateway type) are in neither figure. If product wants adjustments in the overview, add a
 * separate figure rather than folding them into charges.
 */
export const GET_PAYER_MONTHLY_CHARGES = gql`
  query GetPayerMonthlyCharges($where: financial_transaction_log_no_balance_bool_exp!) {
    parkChargesAggregate: financial_transaction_log_no_balance_aggregate(
      where: { _and: [{ status: { _eq: "regular" } }, $where, { transaction_type: { _in: ["park", "trip_charge"] } }] }
    ) {
      aggregate {
        sum {
          price
        }
      }
    }
    gatewayChargesAggregate: financial_transaction_log_no_balance_aggregate(
      where: {
        _and: [
          { status: { _eq: "regular" } }
          $where
          { gateway_transaction_type: { _is_null: false } }
          {
            gateway_transaction_type: {
              _nin: [
                "initial_wallet_load"
                "wallet_reload"
                "wallet_refund"
                "session_payment"
                "invoice"
                "invoice_refund"
              ]
            }
          }
        ]
      }
    ) {
      aggregate {
        sum {
          price
        }
      }
    }
  }
`;

export interface GetPayerMonthlyChargesVars {
  where: PayerTransactionsFilter;
}

interface AggregateSum {
  aggregate: {
    sum: {
      price: number | null;
    };
  };
}

export interface GetPayerMonthlyChargesData {
  parkChargesAggregate: AggregateSum;
  gatewayChargesAggregate: AggregateSum;
}
